var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-linkedin';
                    var viewUrl = 'sprite.svg#view-logo-linkedin';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-linkedin#logo-linkedin';
                            viewUrl = 'sprite.svg?logo-linkedin#view-logo-linkedin';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 50 50',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };